'use strict';

module.exports = require('./matrix').Matrix;
module.exports.Decompositions = module.exports.DC = require('./decompositions');



//////////////////
// WEBPACK FOOTER
// ./~/nmr-simulation/~/ml-matrix/src/index.js
// module id = 17
// module chunks = 0